export const PINTEREST_EVENTS = {
  ADD_TO_CART: 'add_to_cart',
  SIGNUP: 'signup',
  LEAD: 'lead',
  PAGE_VISIT: 'page_visit',
  CHECKOUT: 'checkout',
  SEARCH: 'search',
  VIEW_CATEGORY: 'view_category',
  WATCH_VIDEO: 'watch_video',
  CUSTOM: 'custom',
};

export const PINTEREST_CATEGORIES = {
  SUBSCRIPTION: 'subscription',
  EVENT_ADDON: 'event_addon',
};
